export default [
  {
    path: '/active-recommender/index',
    name: 'Index',
    component: () => import('@/views/active-recommender/index'),
    meta: {
      title: '高考直通车返图推荐领现金红包'
    }
  }, 
  
]
